import { getClientLogoDomain } from '@/utils/clientLogo';
import { useObjectContext } from '@/hooks/useObjectContext';

export const useGetRelationshipCompanyContactData = () => {
	const { relationshipCompany } = useObjectContext();

	const logoDomain = getClientLogoDomain({
		mainContact: relationshipCompany,
		clientRow: relationshipCompany,
	});

	return {
		logoDomain,
		subtitle: relationshipCompany?.contactName,
		contactEmail: relationshipCompany?.email ?? relationshipCompany?.contactEmail,
		contactPhone: relationshipCompany?.phone ?? relationshipCompany?.contactPhone,
	};
};
